// extracted by mini-css-extract-plugin
export var catSummary = "nutritionVis-module--catSummary--B7XUx";
export var chartArea = "nutritionVis-module--chartArea--9pM43";
export var controls = "nutritionVis-module--controls--XNf-I";
export var controlsLabel = "nutritionVis-module--controlsLabel--XFleH";
export var dot = "nutritionVis-module--dot--RdLmN";
export var loading = "nutritionVis-module--loading--dWOW8";
export var nBtn = "nutritionVis-module--nBtn--I3DEG";
export var nBtnActive = "nutritionVis-module--nBtnActive--Puhg0";
export var nButtons = "nutritionVis-module--nButtons--fWDS4";
export var tab = "nutritionVis-module--tab--fKsid";
export var tabActive = "nutritionVis-module--tabActive--Gootk";
export var tabs = "nutritionVis-module--tabs--yn6Zv";
export var title = "nutritionVis-module--title--Qx9x6";
export var tooltip = "nutritionVis-module--tooltip--rADVy";
export var vizSource = "nutritionVis-module--vizSource--6qSeu";
export var wrapper = "nutritionVis-module--wrapper--hNYHx";